import { withTheme } from '@front10/container-elements';
import withCommonEMContainer from '../_commons/CommonEMContainer';
import EventFinderCarouselMobile from './EventFinderCarouselMobile';

export default withCommonEMContainer(withTheme(EventFinderCarouselMobile));
